import React, { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { PageLoading } from 'components/atoms/loading';
import { TemplateState } from 'data/templates/api';
import { createDocumentTemplateAction } from 'data/templates/documents';
import { useTranslation } from 'hooks/use-translation';
import { getTemplatesQueryKey } from 'queries';

export const NewDocumentTemplatePage: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const templateName = useTranslation('untitled');
  const pageTitle = useTranslation('loading');
  const queryClient = useQueryClient();

  useEffect(() => {
    dispatch(
      createDocumentTemplateAction({
        state: TemplateState.Draft,
        templateName,
        handleSuccess: (templateId: number) => {
          history.replace(`/templates/documents/${templateId}`);
          queryClient.invalidateQueries(getTemplatesQueryKey());
        },
      }),
    );
  }, [queryClient, dispatch, history, templateName]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <PageLoading />
    </>
  );
};
